(() => {
    if (document.body.classList.contains('page-template-page-home')) {
        new ScrollDown(document.body);
        new ParallaxScrolling(document.body);
        new SideScroll(document.body);
        new DocumentaryPreview(document.body);
        new BGShape(document.body);
        new InViewAnimation();
    }
})();